import './App.css';
import NavRoutes from './components/router/NavRoutes';

function App() {
  return (
    <div className="App">
      <NavRoutes />
    </div>
  );
}

export default App;
